import { ChevronRight, Play } from 'lucide-react';
import React from 'react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { HeroVideoDialog } from '@/components/ui/hero-video-dialog';

interface DemoSectionProps {
  videoSrc?: string;
  image?: string;
  title: string;
  description: string;
  ctaText: string;
  showBadge?: boolean;
  badgeLabel?: string;
}

const DemoSection: React.FC<DemoSectionProps> = ({
  videoSrc,
  image,
  title,
  description,
  ctaText,
  showBadge = false,
  badgeLabel = '',
}) => {
  return (
    <div className="rounded-lg bg-[#11171F] px-6 py-8 transition-transform duration-300 ease-in-out hover:-translate-y-2 sm:px-20 sm:py-14 lg:flex">
      <div className="lg:w-1/2">
        <div className="mb-6 md:mb-8 lg:mb-0">
          {videoSrc ? (
            <HeroVideoDialog
              videoSrc={videoSrc}
              animationStyle="from-center"
              trigger={
                <div className="group relative cursor-pointer">
                  <img
                    src={image}
                    alt="placeholder"
                    className="w-full rounded-md object-cover"
                  />
                  <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md bg-background/80 p-2 text-muted-foreground transition-colors duration-300 group-hover:text-primary">
                    <Play size={16} strokeWidth={2} />
                  </div>
                </div>
              }
            />
          ) : (
            <img
              src={image}
              alt="placeholder"
              className="w-full rounded-md object-cover"
            />
          )}
        </div>
      </div>
      <div className="lg:flex lg:w-1/2 lg:items-center lg:pl-14">
        <div>
          {showBadge ? (
            <div className="mb-3 flex items-center gap-2">
              <h3 className="text-sm font-medium text-primary">{title}</h3>
              <Badge variant="secondary" className="text-xs">
                {badgeLabel}
              </Badge>
            </div>
          ) : (
            <h3 className="mb-3 text-sm font-medium text-primary">{title}</h3>
          )}
          <p className="mb-8 font-medium leading-7 text-white lg:text-lg">
            {description}
          </p>
          {videoSrc && (
            <HeroVideoDialog
              videoSrc={videoSrc}
              animationStyle="from-center"
              trigger={
                <Button
                  variant="ghost"
                  size="sm"
                  className="group px-0 text-muted-foreground hover:bg-transparent"
                >
                  {ctaText}{' '}
                  <ChevronRight
                    className="ms-1 opacity-60 transition-transform group-hover:translate-x-0.5"
                    size={16}
                    aria-hidden="true"
                  />
                </Button>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DemoSection;
